class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');

    this.observer = new IntersectionObserver(this.handleIntersection.bind(this));
    this.observer.observe(this);

    // Start loading as soon as the shopper shows intent to open the drawer,
    // so the contents are usually ready by the time it slides in
    const summary = this.drawer?.querySelector('summary');
    if (summary) {
      const prefetch = () => this.load();
      ['pointerenter', 'touchstart', 'focusin'].forEach((type) => {
        summary.addEventListener(type, prefetch, { once: true, passive: true });
      });
    }
  }

  handleIntersection(entries) {
    if (!entries[0].isIntersecting) return;
    this.load();
  }

  load() {
    if (this.loaded || this.loading) return;
    this.loading = true;
    this.observer.disconnect();

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        // Contents already rendered by add to cart while this was in flight
        if (this.loaded) return;
        this.loaded = true;

        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');

        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
        // Retry next time the drawer is shown
        setTimeout(() => {
          if (!this.loaded) this.observer.observe(this);
        }, 1000);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    // The add to cart response already holds the drawer contents,
    // so opening the drawer must not fetch them a second time
    this.loaded = true;
    this.observer?.disconnect();

    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
